import Vue from 'vue'
import Vuex from 'vuex'
// Modules
import app from './app'
import appConfig from './app-config'
import auth from './auth'
import eventos from './negociacao/eventos'
import negociacao from './negociacao/negociacao'
import verticalMenu from './vertical-menu'
import negociar from './negociacao/negociar'
import proposta from './negociacao/proposta'
import graficos from './modules/graficos'
import agendamentos from './modules/agendamentos'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    auth,
    eventos,
    negociacao,
    negociar,
    proposta,
    graficos,
    agendamentos,
  },
  strict: process.env.DEV,
})
